<cbs-product-content>
  <cbs-price-summary style="display: block;" class="p-b-base"></cbs-price-summary>
</cbs-product-content>
